/*! For license information please see 39.js.LICENSE.txt */
(self.webpackChunkjuno_shopify_template = self.webpackChunkjuno_shopify_template || []).push([
  [39],
  {
    39: function (e, t, o) {
      function n(e) {
        for (var t = 1; t < arguments.length; t++) {
          var o = arguments[t];
          for (var n in o) e[n] = o[n];
        }
        return e;
      }
      o.r(t),
        o.d(t, {
          GeoIP: function () {
            return s;
          },
        });
      var i = (function e(t, o) {
        function i(e, i, r) {
          if ("undefined" !== typeof document) {
            "number" === typeof (r = n({}, o, r)).expires && (r.expires = new Date(Date.now() + 864e5 * r.expires)),
              r.expires && (r.expires = r.expires.toUTCString()),
              (e = encodeURIComponent(e)
                .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
                .replace(/[()]/g, escape));
            var s = "";
            for (var c in r) r[c] && ((s += "; " + c), !0 !== r[c] && (s += "=" + r[c].split(";")[0]));
            return (document.cookie = e + "=" + t.write(i, e) + s);
          }
        }
        return Object.create(
          {
            set: i,
            get: function (e) {
              if ("undefined" !== typeof document && (!arguments.length || e)) {
                for (var o = document.cookie ? document.cookie.split("; ") : [], n = {}, i = 0; i < o.length; i++) {
                  var r = o[i].split("="),
                    s = r.slice(1).join("=");
                  try {
                    var c = decodeURIComponent(r[0]);
                    if (((n[c] = t.read(s, c)), e === c)) break;
                  } catch (e) { }
                }
                return e ? n[e] : n;
              }
            },
            remove: function (e, t) {
              i(e, "", n({}, t, { expires: -1 }));
            },
            withAttributes: function (t) {
              return e(this.converter, n({}, this.attributes, t));
            },
            withConverter: function (t) {
              return e(n({}, this.converter, t), this.attributes);
            },
          },
          { attributes: { value: Object.freeze(o) }, converter: { value: Object.freeze(t) } }
        );
      })(
        {
          read: function (e) {
            return '"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
          },
          write: function (e) {
            return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
          },
        },
        { path: "/" }
      ),
        r = o(4412);
      class s {
        constructor(e) {
          (this.defaultMarket = {}),
            (this.geoIPDialog = void 0),
            (this.userGeoCountry = ""),
            (this.geoIPDialog = e),
            (this.defaultMarket = window.storeSwitcher.countries.find((e) => !0 === e.default_market)),
            (i.get("geoip_popup_set") && i.get("geoip_popup")) ||
            (this.userGeoCountry = this.getCountry().then(() => {
              this.bindEvents();
            }));
        }
        bindEvents() {
          this.handleDialog();
        }
        async getCountry() {
          const e = await fetch("/browsing_context_suggestions.json");
          if (!e.ok) throw new Error("Something went wrong fetching user country");
          return (await e.json()).detected_values.country.handle.toLowerCase();
        }
        handleDialog() {
          let EUcodes = ["BE","EL","LT","PT","BG","ES","LU","RO","CZ","FR","HU","SI","DK","HR","MT","SK","DE","IT","NL","FI","EE","CY","AT","SE","IE","LV","PL"];
          let countryCode = Shopify.country;
          countryCode = countryCode == "GB" ? "UK"
            : EUcodes.includes(countryCode) ? "EU"
            : countryCode;

          let e = undefined;
          window.storeSwitcher.countries.forEach((country) => {
            if (country.code == countryCode) {
              e = country;
            }
          });
          if (countryCode == "EU" || e == undefined) return;
          const t = (0, r.U2)(".js-geoip-opener");
          t?.click(), this.handleStayClick(), this.handleRedirectClick(e);
        }
        handleStayClick() {
          const e = (0, r.go)("[data-a11y-dialog-hide]", this.geoIPDialog),
            { defaultMarket: t } = this;
          e.forEach((e) => {
            e?.addEventListener("click", function () {
              i.set("geoip_popup_set", !0, { expires: 30 }), i.set("geoip_popup", t.code, { expires: 30 });
            });
          });
        }
        handleRedirectClick(e) {
          const t = (0, r.U2)(".js-geo-redirect-flag", this.geoIPDialog),
            o = e?.image ?? `https://cdn.shopify.com/static/images/flags/${e?.code.toLowerCase()}.svg`;
          t.dataset.src = o;
          const n = (0, r.U2)(".js-geo-redirect-name", this.geoIPDialog),
            i = n?.innerText?.replace("store_name", `${e?.name}`);
          n.innerText = i;
          const s = (0, r.U2)(".js-geo-redirect", this.geoIPDialog);
          s?.addEventListener("click", function () {
            if (e.url) {
              const t = new URL(e.url);
              t.searchParams.set("storeRedirect", e.code), (window.location.href = t.toString());
            } else window.location.href = window.location.origin + window.location.pathname;
          });
        }
      }
    },
  },
]);
